import React from 'react';
import './ProcessFlowchart.css';

const ProcessFlowchart = ({ title, steps = [], interactive = false }) => {
  if (!steps.length) {
    return null;
  }

  return (
    <div className={`process-flowchart ${interactive ? 'process-flowchart--interactive' : ''}`}>
      {title && <h3 className="process-flowchart__title">{title}</h3>}
      <div className="process-flowchart__steps">
        {steps.map((step, index) => (
          <div key={step.id || index} className="process-flowchart__step">
            <div className="process-flowchart__badge">
              <span>{index + 1}</span>
            </div>

            <div className="process-flowchart__content">
              <div className="process-flowchart__header">
                <h4>{step.label || step.title}</h4>
                {step.duration && (
                  <span className="process-flowchart__duration">{step.duration}</span>
                )}
              </div>
              {step.description && <p>{step.description}</p>}
              {step.icon && (
                <div className="process-flowchart__icon" aria-hidden>
                  {step.icon}
                </div>
              )}
            </div>

            {index < steps.length - 1 && (
              <div className="process-flowchart__connector" aria-hidden />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProcessFlowchart;
